/**
 * Split GST-inclusive rupees into taxable + tax for Super Admin plan preview.
 * Plan form amount is INR (rupees); Razorpay stores paise after backend ×100.
 */
export function splitInclusiveGstRupees(amountInclusiveRupees, gstRatePercent) {
  const inclusive = Number(amountInclusiveRupees);
  const rate = Number(gstRatePercent);
  if (!Number.isFinite(inclusive) || inclusive <= 0) {
    return { taxableRupees: 0, taxRupees: 0 };
  }
  const inclusivePaise = Math.round(inclusive * 100);
  const rateDecimal = Number.isFinite(rate) && rate > 0 ? rate / 100 : 0;
  const taxablePaise = rateDecimal > 0
    ? Math.round(inclusivePaise / (1 + rateDecimal))
    : inclusivePaise;
  const taxPaise = inclusivePaise - taxablePaise;
  return { taxableRupees: taxablePaise / 100, taxRupees: taxPaise / 100 };
}

export function buildPlanGstVerbiage(sacCode, gstRatePercent) {
  const sac = sacCode || "998314";
  const rate = gstRatePercent != null ? gstRatePercent : 18;
  return `GST-inclusive. SAC ${sac} @ ${rate}% GST (shown on DocG tax invoice). Clinic GSTIN optional.`;
}
